import React from "react";

import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkRandomWild {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkRandomWild: IframeworkRandomWild = {

    data: {
        "COMPONENTS": [
            {
                "id": "RandomWildContainer",
                "name": "RandomWildContainer",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                child: [

                    {
                        "name": "Particle_01",
                        "image": "Particle_01",
                        "type": "Image",
                        "visible": false,
                        "width": 80,
                        "height": 80,
                        "anchor": [0.5, 0.5],
                        "x": 1815,
                        "y": 800,
                    },
                

                ]
            },

        ]
    }

};

export const RandomWildConfigurationContext = React.createContext(
    {}
);